export const PLACE_MARKS = [
  {
    id: 1,
    geometry: [55.751594, 37.513896],
  },
  {
    id: 2,
    geometry: [55.751574, 37.573856],
  },
  {
    id: 3,
    geometry: [55.781574, 37.773856],
  },
  {
    id: 4,
    geometry: [55.721574, 37.513856],
  },
  {
    id: 5,
    geometry: [55.721574, 37.713856],
  }
];
